import {AbstractModel} from '../abstract-model';
import {Offer} from '../offer';

export class PartnerCappingRule extends AbstractModel {
  id: number | null = null;
  name: string | null = null;
  offer: Offer | null = null;
  subid: string | null = null;
  periodicity: string | null = null;
  capping: number | null = null;
  blockTraffic: boolean = true;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.offer) {
      this.offer = new Offer().deserialize(input.offer);
    }

    return this;
  }

  override toString(): string {
    return this.name ?? '';
  }
}
